import _ from "lodash";
import Requests from "../../services/api/layout-folder";
import LayoutRequest from "../../services/api/layout";
import {createModal} from "../../components/modules/layout-folder-browser/modals/action-creater";
import FileBrowser from '@frontend/services/api/file-browser'

const listRequests = new WeakMap();

const getUrlParams = (hashUrl) => {
  const [pathPart, searchPart = ''] = hashUrl.split('?');
  const lastSegment = pathPart.split('/').pop();
  const folderId = pathPart.startsWith('#layout-folders/') && /^\d+$/.test(lastSegment)
    ? lastSegment : null;
  const urlParams = new URLSearchParams(searchPart);

  return {
    currentPage: Math.max(1, Number(urlParams.get('page')) || 1),
    searchQuery: urlParams.get('search') || '',
    currentFolderId: folderId
  };
}

const initState = () => ({
    isFileBrowserModalOpened: false,
    fileBrowserModalType: '',
    multiselectEnabled: false,
    isListLoading: false,
    items: [],
    progressingItems: [],
    selected: [],
    currentFolderId: null,
    currentFolderName: '',
    pagination: {
        currentPage: 1,
        pageSize: null,
        pageSizeInvalidFeedback: null,
        pageSizeValidationState: null,
        totalCount: 0,
        lastPage: 1,
    },
    previousPages: [],
    searchQuery: '',
    modal: {
        type: '',
        payload: null,
    },
    breadcrumbs: [],
    customerId: null,
    currentHashUrl: '',
    sortBy: 'created_at',
    sortDirection: 'asc',
    actionType: null,
    firstLoading: true,
    selectedFoldersToCopyMove: [],
    isFolder: false
})

export const MUTATIONS = {
    SET_ITEMS: 'SET_ITEMS',
    UPDATE_PROGRESS_PERCENTAGE: 'UPDATE_PROGRESS_PERCENTAGE',
    SET_LIST_LOADING: 'SET_LIST_LOADING',
    SET_TOTAL_COUNT: 'SET_TOTAL_COUNT',
    SET_LAST_PAGE: 'SET_LAST_PAGE',
    SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
    SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
    TOGGLE_SELECTED_ITEMS: 'TOGGLE_SELECTED_ITEMS',
    CLEAR_SELECTION: 'CLEAR_SELECTION',
    SET_MODAL: 'SET_MODAL',
    FINISH_PROGRESSING: 'FINISH_PROGRESSING',
    UPDATE_ITEM_NAME: 'UPDATE_ITEM_NAME',
    SET_BREADCRUMBS: 'SET_BREADCRUMBS',
    SET_SHOW_ONLY_FOLDERS: 'SET_SHOW_ONLY_FOLDERS',
    SET_CURRENT_FOLDER_ID: 'SET_CURRENT_FOLDER_ID',
    SET_CURRENT_FOLDER_NAME: 'SET_CURRENT_FOLDER_NAME',
    SET_MULTISELECT_ENABLED: 'SET_MULTISELECT_ENABLED',
    SET_IS_FILE_BROWSER_MODAL_OPENED: 'SET_IS_FILE_BROWSER_MODAL_OPENED',
    SET_FILE_BROWSER_MODAL_TYPE: 'SET_FILE_BROWSER_MODAL_TYPE',
    SET_SELECTION: 'SET_SELECTION',
    SET_CUSTOMER_ID: 'SET_CUSTOMER_ID',
    SET_CURRENT_HASH_URL: 'SET_CURRENT_HASH_URL',
    SET_ACTION_TYPE: 'SET_ACTION_TYPE',
    SET_FIRST_LOADING: 'SET_FIRST_LOADING',
    SET_SELECTED_COPY_MOVE: 'SET_SELECTED_COPY_MOVE',
    SET_IS_FOLDER: 'SET_IS_FOLDER',
}

export default {
    namespaced: true,
    state: initState(),
    getters: {
        isListLoading: state => state.isListLoading,
        items: state => state.items,
        selected: state => state.selected,
        firstSelectedItem: state => state.selected.length && state.items.find(item => item.id === state.selected[0]),
        selectedItems: state => state.selected.map(selectedId => state.items.find(item => item.id === selectedId)),
        selectedFolders: state => state.items.filter(item => item.type === 'folder' && state.selected.includes(item.id)).map(item => item.id),
        totalCount: state => state.pagination.totalCount,
        pageSize: state => state.pagination.pageSize,
        pageSizeInvalidFeedback: state => state.pagination.pageSizeInvalidFeedback,
        pageSizeValidationState: state => state.pagination.pageSizeValidationState,
        currentPage: state => state.pagination.currentPage,
        searchQuery: state => state.searchQuery,
        isSelected: state => item => state.selected.includes(item.id),
        selectedCount: state => state.selected.length,
        isAnySelected: state => !!state.selected.length,
        modal: state => state.modal,
        breadcrumbs: state => state.breadcrumbs,
        currentFolderId: state => state.currentFolderId,
        currentFolderName: state => state.currentFolderName,
        multiselectEnabled: state => state.multiselectEnabled,
        isFileBrowserModalOpened: state => state.isFileBrowserModalOpened,
        fileBrowserModalType: state => state.fileBrowserModalType,
        customerId: state => state.customerId,
        currentHashUrl: state => state.currentHashUrl,
        sort: state => ({ sortBy: state.sortBy, sortDirection: state.sortDirection }),
        actionType: state => state.actionType,
        firstLoading: state => state.firstLoading,
        pagination: state => state.pagination,
        selectedFoldersToCopyMove: state => state.selectedFoldersToCopyMove,
        isFolder: state => state.isFolder
    },
    mutations: {
        [MUTATIONS.SET_SELECTED_COPY_MOVE](state, payload) {
          if (payload.length === 0) {
            state.selectedFoldersToCopyMove.length = 0;
          } else {
            state.selectedFoldersToCopyMove.push(...payload);  
          }
        },
        [MUTATIONS.SET_LIST_LOADING](state, payload) {
            state.isListLoading = payload;
        },
        [MUTATIONS.SET_ITEMS](state, payload) {
            state.items = payload;
        },
        [MUTATIONS.SET_TOTAL_COUNT](state, payload) {
            state.pagination.totalCount = payload
        },
        [MUTATIONS.SET_LAST_PAGE](state, payload) {
            state.pagination.lastPage = payload
        },
        [MUTATIONS.SET_CURRENT_PAGE](state, payload) {
          state.pagination.currentPage = Math.max(1, Number(payload) || 1)
        },
        [MUTATIONS.SET_SEARCH_QUERY](state, payload) {
          state.searchQuery = payload
        },
        [MUTATIONS.TOGGLE_SELECTED_ITEMS](state, id) {
            if (state.selected.includes(id)) {
                state.selected.splice(state.selected.indexOf(id), 1)
            } else {
                state.selected.push(id)
            }
        },
        [MUTATIONS.CLEAR_SELECTION](state) {
            state.selected = [];
        },
        [MUTATIONS.SET_SELECTION](state, payload) {
            state.selected = payload
        },
        [MUTATIONS.SET_MODAL](state, payload) {
            state.modal = payload;
        },
        [MUTATIONS.UPDATE_ITEM_NAME](state, { id, name }) {
            const item = state.items.find(item => item.id === id);

            if (!item) {
                return;
            }

            item.name = name;
        },
        [MUTATIONS.SET_BREADCRUMBS](state, payload) {
            state.breadcrumbs = payload;
        },
        [MUTATIONS.SET_SHOW_ONLY_FOLDERS] (state, payload) {
            state.showOnlyFolders = payload
        },
        [MUTATIONS.SET_CURRENT_FOLDER_ID] (state, payload) {
          state.currentFolderId = payload
        },
        [MUTATIONS.SET_CURRENT_FOLDER_NAME] (state, payload) {
          state.currentFolderName = payload
        },
        [MUTATIONS.SET_MULTISELECT_ENABLED] (state, payload) {
          state.multiselectEnabled = payload
        },
        [MUTATIONS.SET_IS_FILE_BROWSER_MODAL_OPENED] (state, payload) {
          state.isFileBrowserModalOpened = payload
        },
        [MUTATIONS.SET_FILE_BROWSER_MODAL_TYPE] (state, payload) {
          state.fileBrowserModalType = payload
        },
        [MUTATIONS.SET_CUSTOMER_ID] (state, payload) {
          state.customerId = payload;
        },
        [MUTATIONS.SET_CURRENT_HASH_URL] (state, payload) {
          state.currentHashUrl = payload;
        },
        [MUTATIONS.SET_ACTION_TYPE] (state, payload) {
          state.actionType = payload;
        },
        SET_PAGE_SIZE (state, payload) {
          state.pagination.pageSize = payload
        },
        SET_PAGE_SIZE_VALIDATION (state, payload) {
          state.pagination.pageSizeInvalidFeedback = payload.pageSizeInvalidFeedback
          state.pagination.pageSizeValidationState = payload.pageSizeValidationState
        },
        PUSH_PREVIOUS_PAGE (state, payload) {
          state.previousPages.push(payload)
        },
        POP_PREVIOUS_PAGE (state) {
          state.previousPages.pop()
        },
        SET_SORT (state, payload) {
          state.sortBy = payload.sortBy
          state.sortDirection = payload.sortDirection
        },
        [MUTATIONS.SET_FIRST_LOADING] (state) {
          state.firstLoading = false
        },
        [MUTATIONS.SET_IS_FOLDER] (state, payload) {
          state.isFolder = payload
        }
    },
    actions: {
        async fetchList({ commit, state }) {
          if (state.firstLoading) {
            if (!state.isFileBrowserModalOpened && /^#layout-folders(?:\/|\?|$)/.test(window.location.hash)) {
              const params = getUrlParams(window.location.hash);
              commit(MUTATIONS.SET_CURRENT_HASH_URL, window.location.hash);
              commit(MUTATIONS.SET_CURRENT_PAGE, params.currentPage);
              commit(MUTATIONS.SET_SEARCH_QUERY, params.searchQuery);
              commit(MUTATIONS.SET_CURRENT_FOLDER_ID, params.currentFolderId);
            }
            commit(MUTATIONS.SET_FIRST_LOADING);
          }

          const params = {
            pageSize: state.pagination.pageSize,
            pageNumber: state.pagination.currentPage,
            searchKey: state.searchQuery,
            parentId: state.currentFolderId,
            sortBy: state.sortBy,
            sortDirection: state.sortDirection,
          };
          const key = JSON.stringify(params);
          const pending = listRequests.get(state);
          if (state.isListLoading && pending?.key === key) return pending.promise;
          const request = { key };
          listRequests.set(state, request);
          commit(MUTATIONS.SET_LIST_LOADING, true);
          request.promise = (async () => {
            try {
              const { data } = await Requests.getFolders(params);
              if (listRequests.get(state) !== request) return;
              const breadcrumbs = data.breadcrumbs.map(folder => ({ id: folder.id, text: folder.name }));
              commit(MUTATIONS.SET_BREADCRUMBS, breadcrumbs);
              commit(MUTATIONS.SET_CURRENT_FOLDER_NAME, breadcrumbs[breadcrumbs.length - 1]?.text || '');
              commit(MUTATIONS.SET_ITEMS, data.items);
              commit(MUTATIONS.SET_TOTAL_COUNT, data.totalCount);
              commit(MUTATIONS.SET_LAST_PAGE, data.last_page);
              commit(MUTATIONS.SET_CURRENT_PAGE, data.current_page);
              commit(MUTATIONS.CLEAR_SELECTION);
            } finally {
              if (listRequests.get(state) === request) {
                commit(MUTATIONS.SET_LIST_LOADING, false);
              }
            }
          })();
          return request.promise;
        },
      async fetchUsingUrl({ commit, dispatch }) {
          const hash = window.location.hash;
          if (!/^#layout-folders(?:\/|\?|$)/.test(hash)) return;
          const params = getUrlParams(hash);
          commit(MUTATIONS.SET_CURRENT_HASH_URL, hash);
          commit(MUTATIONS.SET_CURRENT_PAGE, params.currentPage);
          commit(MUTATIONS.SET_SEARCH_QUERY, params.searchQuery);
          commit(MUTATIONS.SET_CURRENT_FOLDER_ID, params.currentFolderId);
          commit(MUTATIONS.SET_CURRENT_FOLDER_NAME, '');
          await dispatch('fetchList');
      },
      setCurrentHashUrl({ commit }, payload) {
          commit(MUTATIONS.SET_CURRENT_HASH_URL, payload);
          window.location.hash = payload;
      },
      async addFolder({ dispatch, commit, state }) {
            await Requests.createFolder(state.currentFolderId);
            await dispatch('fetchList');
            await dispatch('setCurrentPage', Math.max(1, state.pagination.lastPage));
        },
        async deleteById({ commit, dispatch, state }, item) {
            try {
                const wasOnLastPage = state.pagination.currentPage === state.pagination.lastPage;
                
                await Requests.deleteFolder(item.id);
                await dispatch('fetchList');
                if (wasOnLastPage) {
                  await dispatch('setCurrentPage', Math.max(1, state.pagination.lastPage));
                }
                window.livewire.emit('updatedGridLayoutsIds', []);
            } finally {
                commit(MUTATIONS.SET_MODAL, createModal())
            }
        },
        async editFile({ commit }, { id, name, parent_id }) {
            try {
                await Requests.editFolder(id, name);
                commit(MUTATIONS.UPDATE_ITEM_NAME, { id, name })
                toastr.success('Folder renamed successfully')
            } catch (error) {
                toastr.error('Something went wrong on updating name')
            } finally {
                commit(MUTATIONS.SET_MODAL, createModal());
            }
        },
        clearSelection ({ commit }) {
            commit(MUTATIONS.CLEAR_SELECTION)
        },
        selectAll ({ commit, state }) {
            commit(MUTATIONS.SET_SELECTION, _.filter(_.map(state.items, 'id')))
        },
        setShowOnlyFolders({ commit }, payload) {
            commit(MUTATIONS.SET_SHOW_ONLY_FOLDERS, payload)
        },
        setCurrentFolder({ commit, state, dispatch }, payload) {
          if (payload?.parent_id !== undefined) {
            commit('PUSH_PREVIOUS_PAGE', +state.pagination.currentPage)
            commit(MUTATIONS.SET_CURRENT_PAGE, 1)
          } else {
            const previousPage = state.previousPages.at(-1)
            if (previousPage !== undefined && previousPage !== null) {
              commit('POP_PREVIOUS_PAGE')
              commit(MUTATIONS.SET_CURRENT_PAGE, previousPage)
            } else {
              commit(MUTATIONS.SET_CURRENT_PAGE, 1)
            }
          }
          commit(MUTATIONS.SET_SEARCH_QUERY, '')
          commit(MUTATIONS.SET_CURRENT_FOLDER_ID, payload?.id || null)
          commit(MUTATIONS.SET_CURRENT_FOLDER_NAME, payload?.name || null)
        },
        setCurrentPage({ commit, dispatch, state }, payload) {
          commit(MUTATIONS.SET_CURRENT_PAGE, payload)
          dispatch('fetchList')
        },
        setSearchQuery({ commit, dispatch, state }, payload) {
          commit(MUTATIONS.SET_CURRENT_PAGE, 1)
          commit(MUTATIONS.SET_SEARCH_QUERY, payload)
          dispatch('fetchList')
        },
        disableMultiselect({ commit }) {
          commit(MUTATIONS.SET_MULTISELECT_ENABLED, false)
        },
        setIsFileBrowserModalOpened({ commit, state }, payload) {
          commit(MUTATIONS.SET_IS_FILE_BROWSER_MODAL_OPENED, payload);
        },
        openFileBrowserModal({ commit, state }, payload) {
          commit(MUTATIONS.CLEAR_SELECTION)
          commit(MUTATIONS.SET_CURRENT_PAGE, 1)
          commit(MUTATIONS.SET_SEARCH_QUERY, '')
          
          if (payload.type === 'Copy') {
            commit(MUTATIONS.SET_MULTISELECT_ENABLED, true);
          }
          
          commit(MUTATIONS.SET_IS_FILE_BROWSER_MODAL_OPENED, true);
          commit(MUTATIONS.SET_FILE_BROWSER_MODAL_TYPE, payload.type);
        },
        async moveItemsToFolder({ commit, dispatch, state }, payload ) {
          const draggedLayouts = payload.items.filter(item => item.type === 'layout')
          const draggedFolders = payload.items.filter(item => item.type === 'folder');

          if (draggedLayouts.length > 0) {
            await Requests.moveLayoutsToFolder(payload.folderId, draggedLayouts.map(layout => layout.grid_layout_id));
          }

          if (draggedFolders.length > 0) {
            await Requests.moveFoldersToFolder(payload.folderId, draggedFolders.map(folder => folder.id));
          }
          
          dispatch('fetchList');
        },
        async archiveLayout({ commit, dispatch, state }, item) {
          await Requests.archiveLayout(item.customer_id, item.grid_layout_id);
          dispatch('fetchList');
        },
        async removeLayout({ commit, dispatch, state }, item) {
          await Requests.deleteFolderLayouts(state.currentFolderId, [item.grid_layout_id]);
          dispatch('fetchList');
        },
        async copyLayout({ commit, dispatch, state }, item) {
          const data = await LayoutRequest.copy(item.grid_layout_id);
          const lastPage = state.pagination.lastPage;
          await dispatch('fetchList');
          
          if (state.pagination.currentPage !== lastPage) {
            commit(MUTATIONS.SET_CURRENT_PAGE, state.pagination.lastPage);
            await dispatch('fetchList');
          }
          
          dispatch('clearSelection');

          const newLayoutId = data.new_layout_id;
          const newItem = state.items.find(item => item.grid_layout_id === newLayoutId);
          
          if (newItem) {
            commit(MUTATIONS.SET_SELECTION, [newItem.id])
          }
        },

        async fetchPageSize ({ commit, dispatch }) {
          const { data } = await FileBrowser.itemsPerPage()
          commit('SET_PAGE_SIZE', data)
          dispatch('fetchList')
        },

        async updatePageSize ({ commit, dispatch }, payload) {
          let pageSizeInvalidFeedback = null
          let pageSizeValidationState = null
          try {
            const { data } = await FileBrowser.itemsPerPage(payload)
            commit('SET_PAGE_SIZE', data)
            dispatch('fetchList')
          } catch (error) {
            pageSizeInvalidFeedback = Object.values(error.response.data.errors).flat().at(0)
            pageSizeValidationState = false
          } finally {
            commit('SET_PAGE_SIZE_VALIDATION', { pageSizeInvalidFeedback, pageSizeValidationState })
          }
        },
      setActionType({ commit, state }, payload) {
        commit(MUTATIONS.SET_ACTION_TYPE, payload);
      },
      clearSelections({ commit }) {
          commit(MUTATIONS.CLEAR_SELECTION, []);
          commit(MUTATIONS.SET_SELECTED_COPY_MOVE, []);
      }
    }
}
